import { createContext } from 'react';

export type UrlsAssetType = {
	urlAsset: string,
	urlAssetView: string,
	urlAssetViewFull: string,
	urlAssetViewThumb: string,
}

const urlsAssetDefaults: UrlsAssetType = {
	urlAsset: "",
	urlAssetView: "",
	urlAssetViewFull: "",
	urlAssetViewThumb: "",
}

export type UrlsType = {
	asset: {
		url?: string, // rest endpoint
		view?: string,
		viewFull?: string,
		viewThumb?: string,
	},
	page: {
		url?: string, // rest endpoint
		categories?: string,
		services?: string,
		faqs?: string,
		urlCheck?: string,
		clone?: string,
		adminEdit?: string,
		adminList?: string,
	}
}

export type UrlListType = {
	urlList: string,
	urlEdit: string,
	urlOrder: string,
}

const urlsListDefaults: UrlListType = {
	urlList: "",
	urlEdit: "",
	urlOrder: "",
}

export const ContextUrlListApi: React.Context<UrlListType> = createContext(urlsListDefaults);
export const ContextUrls: React.Context<UrlsType> = createContext({asset: {}, page: {}});
